var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9366 8.75073C15.8684 8.8633 12.8946 11.5111 11.1815 13.0588C10.3833 13.78 9.63934 14.7808 10.1375 15.7342C10.3239 16.091 10.6032 16.3391 10.8668 16.5341C11.1173 16.7195 11.4404 16.9177 11.7999 17.1382L14.4578 18.7686C15.0343 19.1223 15.5234 19.4223 15.9366 19.6275C16.3613 19.8384 16.8258 20.0129 17.3414 19.9991C18.0741 19.9797 18.7747 19.6776 19.2864 19.1503C19.6494 18.7763 19.8282 18.3119 19.9501 17.8592C20.0683 17.4204 20.1638 16.8638 20.2755 16.2126L21.8488 7.04464C21.9111 6.68147 21.9693 6.34231 21.9905 6.06334C22.0121 5.77996 22.014 5.38409 21.8144 5.00234C21.5632 4.52171 21.1177 4.17887 20.6002 4.04814C20.1941 3.94556 19.8148 4.02693 19.5389 4.10664C19.2664 4.18533 18.9407 4.31189 18.5868 4.44943L4.61804 9.87634C4.05893 10.0935 3.58113 10.2791 3.2276 10.4512C2.92022 10.6007 2.43154 10.8592 2.18994 11.3506C1.90613 11.928 1.94269 12.6074 2.28406 13.151C2.57431 13.6132 3.08483 13.8211 3.40666 13.9396C3.77618 14.0756 4.27079 14.2128 4.84998 14.3735L5.43408 14.5356C6.00118 14.6933 6.44206 14.816 6.89597 14.8304C7.29575 14.8431 7.69524 14.792 8.07871 14.6789C8.20506 14.6416 8.37041 14.571 8.54152 14.4896C9.1358 14.2067 9.62571 13.7649 10.1375 13.351L15.9366 8.75073Z",
    fill: "#609F81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.100463542e571d089fd38befe38139d5.svg";
export { ForwardRef as ReactComponent };